var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.873 18.875V17.125C14.873 16.1967 14.5043 15.3065 13.8479 14.6501C13.1915 13.9937 12.3013 13.625 11.373 13.625H4.37305C3.44479 13.625 2.55455 13.9937 1.89817 14.6501C1.2418 15.3065 0.873047 16.1967 0.873047 17.125V18.875",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87695 10.125C9.80995 10.125 11.377 8.558 11.377 6.625C11.377 4.692 9.80995 3.125 7.87695 3.125C5.94396 3.125 4.37695 4.692 4.37695 6.625C4.37695 8.558 5.94396 10.125 7.87695 10.125Z",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.127 18.8784V17.1284C20.1264 16.3529 19.8683 15.5996 19.3931 14.9867C18.918 14.3738 18.2528 13.9361 17.502 13.7422",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.998 3.24219C14.7509 3.43495 15.4182 3.8728 15.8947 4.48671C16.3713 5.10062 16.6299 5.85566 16.6299 6.63281C16.6299 7.40996 16.3713 8.16501 15.8947 8.77892C15.4182 9.39282 14.7509 9.83067 13.998 10.0234",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.fcfc499fea78584431b874852ef416e3.svg";
export { ForwardRef as ReactComponent };